import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9c70a7ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'Ios'
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList2 = [{
      label: '85%',
      value: '0.85'
    }, {
      label: '70%',
      value: '0.7'
    }]; // 分成比例
    const iosRef = ref(null); // ios支付ref
    const iosForm = reactive({
      divide: '0.85',
      pkg: ''
    }); // ios支付
    const validateForm = () => {
      var _iosRef$value;
      (_iosRef$value = iosRef.value) === null || _iosRef$value === void 0 || _iosRef$value.validate().then(() => {
        emit('submitForm', iosForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        iosForm.pkg = n.pkg;
        iosForm.divide = n.divide;
        iosForm.id = n.id;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: iosForm,
        ref_key: "iosRef",
        ref: iosRef,
        rules: __props.rules,
        name: "ios-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: iosForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => iosForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: iosForm.divide,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => iosForm.divide = $event),
            options: divideList2,
            disabled: ""
          }, null, 8, ["value"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("默认分成比例为85%，若新增应用需设置为70%，请手动选择")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});